<script>
import CommonService from '../../services/common';
import CommonConstants from '../../common/Constants';
import config from '../../common/genericPanelConf';
import Utils from '../../common/Utils';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue'
// import GenericDataTable from '../../components/generic/GenericDataTable.vue'
import GenericBooleanDropdown from '../../components/generic/GenericBooleanDropdown.vue'

export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
        ResponsiveButton,
        GenericCustomMasterDataAutocompleteV2,
        GenericBooleanDropdown
  },
  data(){
    return {
      data: [],
      loading: false,
      filters: {
        from:  Utils.formatDatePlusMonths(new Date(), -1),
        to:  Utils.formatDatePlusMonths(new Date(), 1),
        voyageNumber: null,
        idRegistryPlant: null,
        idRegistryVessel: null,
        idPortOrLocationOfLoading: null,
        idPortOrLocationOfDischarge: null,
        idRegistryProduct: null,
        isCompleted: null
      }
    }
  },
  validations(){
    return {
      filters: {
        from: {required},
        to: {required},
      }
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    this.configuration = config.getConfiguration('DischargeTrackingReport');
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'DischargeTrackingReport.page_title');
    this.loadFromCache();
  },
  methods: {
     load(){
        this.submitted = true;

        if(this.v$.invalid){
            return;
        }
        this.submitted = false;

        let filters = {
            referenceDateFrom: Utils.formatDatePlusDays(this.filters.from, 0),
            referenceDateTo: Utils.formatEndDate(this.filters.to),
            voyageNumber: this.filters.voyageNumber,
            idRegistryPlant: this.filters.idRegistryPlant,
            idRegistryVessel: this.filters.idRegistryVessel,
            idPortOrLocationOfLoading: this.filters.idPortOrLocationOfLoading,
            idPortOrLocationOfDischarge: this.filters.idPortOrLocationOfDischarge,
            idRegistryProduct: this.filters.idRegistryProduct,
            isCompleted: this.filters.isCompleted
        }

        this.saveCache();

        this.loading = true;
        CommonService.createItem('vessel-protocol-discharge-tracking-list', filters, response => {
          this.loading = false;
          if(response.success){
              this.data = response.data;
          }else{
              this.data = [];
          }
      });
        
        // this.$refs.dischargeTrackingReportGrid.filterFromView(filters, true);
    },
    showDetails(item){
      let uri = `/discharge-tracking-detail/${item.id}`;
      this.$router.push(uri);
    },
    loadFromCache(){
      let cacheData = this.$store.getters['cacheDataStore/getGridCache']('vessel-protocol-discharge-tracking-list');
      if(cacheData){
        
        this.filters.from = cacheData.referenceDateFrom;
        this.filters.to = cacheData.referenceDateTo;
        this.filters.voyageNumber = cacheData.voyageNumber;
        this.filters.idRegistryPlant = cacheData.idRegistryPlant;
        this.filters.idRegistryVessel = cacheData.idRegistryVessel;
        this.filters.idPortOrLocationOfLoading = cacheData.idPortOrLocationOfLoading;
        this.filters.idPortOrLocationOfDischarge = cacheData.idPortOrLocationOfDischarge;
        this.filters.idRegistryProduct = cacheData.idRegistryProduct;
        this.filters.isCompleted = cacheData.isCompleted;

        this.load();
      }
    },
    saveCache(){
      let cacheData = {
        name: 'vessel-protocol-discharge-tracking-list',
                
        filters: {
          referenceDateFrom: this.filters.from,
          referenceDateTo: this.filters.to,
          voyageNumber: this.filters.voyageNumber,
          idRegistryPlant: this.filters.idRegistryPlant,
          idRegistryVessel: this.filters.idRegistryVessel,
          idPortOrLocationOfLoading: this.filters.idPortOrLocationOfLoading,
          idPortOrLocationOfDischarge: this.filters.idPortOrLocationOfDischarge,
          idRegistryProduct: this.filters.idRegistryProduct,
          isCompleted: this.filters.isCompleted
        }
      };
      this.$store.dispatch("cacheDataStore/setGridCache", cacheData);
    }
  }
}

</script>

<template>
  <main>
    <div class="grid">
        <div class="col-12 lg:col-2 field">
            <label for="from" :class="{'p-error':v$.filters.from.$invalid && submitted}">{{$t('from')}}</label>
            <Calendar
                :class="{'p-invalid':v$.filters.from.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false"
                v-model="filters.from"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>
            <div v-if="(v$.filters.from.$invalid && submitted) || v$.filters.from.$pending.$response">
                <small class="p-error" v-for="error in v$.filters.from.$silentErrors" :key="error.$validator">
                    {{error.$message}}
                </small>
            </div>
        <div class="col-12 lg:col-2 field">
            <label for="to" :class="{'p-error':v$.filters.to.$invalid && submitted}">{{$t('to')}}</label>
            <Calendar
                :class="{'p-invalid':v$.filters.to.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false"
                v-model="filters.to"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            <div v-if="(v$.filters.to.$invalid && submitted) || v$.filters.to.$pending.$response">
                <small class="p-error" v-for="error in v$.filters.to.$silentErrors" :key="error.$validator">
                    {{error.$message}}
                </small>
            </div>
        </div>
        <div class="col-12 lg:col-2 field">
          <label for="voyageNumber">{{$t('movementInstructions.voyageNumber')}}</label>
          <InputText  id="voyageNumber" type="text" v-model="filters.voyageNumber" :class="{'w-full p-inputtext-sm': true}" />
        </div>
        <div class="col-12 lg:col-2 field">
            <label for="plant">{{$t('registryPlant.fk')}}</label>
            <GenericCustomMasterDataAutocompleteV2
              ref="plantAutocomplete"
              v-model="filters.idRegistryPlant"
              name="plants" 
              api="masterdata/registry-plant-combo"
              :format="{ label: 'code', value: 'id' }" sortField="Code"
              :class="{'w-full p-inputtext-sm mt-1 ': true}" />
        </div>
        <div class="col-12 lg:col-2 field">
            <label for="idRegistryVessel">{{$t('vessel.fk')}}</label>
            <GenericCustomMasterDataAutocompleteV2
              v-model="filters.idRegistryVessel"
              name="registry-vessels" 
              api="masterdata/vessel-combo?getOnlyValid=true"
              :class="{'w-full p-inputtext-sm': true}" />
        </div>
         <div class="col-12 lg:col-2 field">
            <label for="loadingPort">{{$t('DischargeTrackingReport.loadingPort')}}</label>
            <GenericCustomMasterDataAutocompleteV2
              v-model="filters.idPortOrLocationOfLoading"
              name="ports-and-locations" 
              api="masterdata/port-and-location-combo"
              :class="{'w-full p-inputtext-sm': true}" />
        </div>
        <div class="col-12 lg:col-2 field">
          <label for="dischargePort">{{$t('DischargeTrackingReport.dischargePort')}}</label>
          <GenericCustomMasterDataAutocompleteV2
            v-model="filters.idPortOrLocationOfDischarge"
            name="ports-and-locations" 
            api="masterdata/port-and-location-combo"
            :class="{'w-full p-inputtext-sm': true}" />
        </div>
        <div class="col-12 lg:col-2 field">
            <label for="idRegistryProduct">{{$t('product.fk')}}</label>
            <GenericCustomMasterDataAutocompleteV2
              v-model="filters.idRegistryProduct"
              name="products" 
              api="masterdata/product-combo"
              :class="{'w-full p-inputtext-sm ': true}" />
        </div>
        <div class="col-12 lg:col-2 field">
          <label for="isCompleted">{{$t('DischargeTrackingReport.isCompleted')}}</label>
          <GenericBooleanDropdown
            id="isCompleted" 
            showClear
            v-model="filters.isCompleted" 
            :class="{'w-full p-inputtext-sm ': true}"
          />
        </div>
        <div class="col-12 lg:col-6 field">
            <div class="p-4">
                <ResponsiveButton :label="$t('btn.search')" icon="pi pi-search" class="mx-1" @click="load()"/>   
            </div>
        </div>
        <div class="col-12" style="height: calc(75vh)">
          <DataTable :value="data" :reorderableColumns="true" :loading="loading">
            <Column class="" :exportable="false" :header="'Show Details'">
                <template #body="slotProps">
                    <Button icon="pi pi-eye" class="p-button-sm p-button-rounded p-button-outlined p-button-success mr-1 mb-1" v-tooltip="$t('details')" @click="showDetails(slotProps.data)"  />
                </template>
            </Column>
              <Column field="isCompleted" :header="$t('DischargeTrackingReport.isCompleted')">
                <template #body="{data}">
                  <!-- {{data.isCompleted ? $t('yes'): $t('no')}} -->
                  <i :class="{'fa-solid fa-check-circle text-green-400': data.isCompleted, 'fa-solid fa-circle-xmark text-pink-600' : !data.isCompleted}" style="font-size: 25px"></i>
                </template>
              </Column>
              <Column field="referenceDate" :header="$t('DischargeTrackingReport.referenceDate')">
                <template #body="{data}">
                  {{data.referenceDate != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data.referenceDate)) : null}}
                </template>
              </Column>
              <Column field="voyageNumber" :header="$t('movementInstructions.voyageNumber')">
                <template #body="{data}">
                  {{data.voyageNumber}}
                </template>
              </Column>
              <Column field="lotCode" :header="$t('movementInstructionLots.lotCode')">
                <template #body="{data}">
                  {{data.lotCode}}
                </template>
              </Column>
              <Column field="plant" :header="$t('registryPlant.fk')">
                <template #body="{data}">
                  {{data.plant}}
                </template>
              </Column>
              <Column field="vesselName" :header="$t('vessel.fk')">
                <template #body="{data}">
                  {{data.vesselName}}
                </template>
              </Column>
              <Column field="product" :header="$t('product.fk')">
                <template #body="{data}">
                  {{data.product}}
                </template>
              </Column>
              <Column field="origin" :header="$t('vesselProtocol.originCountryProduct')">
                <template #body="{data}">
                  {{data.origin}}
                </template>
              </Column>
              <Column field="loadingPort" :header="$t('DischargeTrackingReport.loadingPort')">
                <template #body="{data}">
                  {{data.loadingPort}}
                </template>
              </Column>
              <Column field="dischargePort" :header="$t('DischargeTrackingReport.dischargePort')">
                <template #body="{data}">
                  {{data.dischargePort}}
                </template>
              </Column>
              <Column field="certificateOfOriginStatus" :header="$t('DischargeTrackingReport.certificateOfOriginStatus')">
                <template #body="{data}">
                  {{data.certificateOfOriginStatus ? $t('DischargeTrackingReport.status.' + data.certificateOfOriginStatus) : ''}}
                </template>
              </Column>
              <Column field="suppliersDeclarationStatus">
                <template #header>
                  <p>
                    {{ $t('DischargeTrackingReport.suppliersDeclarationStatus') }}
                    <i class="fa-solid fa-info-circle" v-tooltip="$t('DischargeTrackingReport.infoSuppliersDeclaration')" />
                  </p>
                </template>
                <template #body="{data}">
                  {{data.suppliersDeclarationStatus ? $t('DischargeTrackingReport.status.' + data.suppliersDeclarationStatus) : ''}}
                </template>
              </Column>
              <Column field="exportDeclarationStatus" >
                <template #header>
                  <p>
                    {{ $t('DischargeTrackingReport.exportDeclarationStatus') }}
                    <i class="fa-solid fa-info-circle" v-tooltip="$t('DischargeTrackingReport.infoExportDeclaration')" />
                  </p>
                </template>
                <template #body="{data}">
                  {{data.exportDeclarationStatus ? $t('DischargeTrackingReport.status.' + data.exportDeclarationStatus) : ''}}
                </template>
              </Column>
              <Column field="nonManipulationDeclarationStatus">
                <template #header>
                  <p>
                    {{ $t('DischargeTrackingReport.nonManipulationDeclarationStatus') }}
                    <i class="fa-solid fa-info-circle" v-tooltip="$t('DischargeTrackingReport.infoNonManipulation')" />
                  </p>
                </template>
                <template #body="{data}">
                  {{data.nonManipulationDeclarationStatus ? $t('DischargeTrackingReport.status.' + data.nonManipulationDeclarationStatus) : ''}}
                </template>
              </Column>
              <Column field="voyageReportStatus" :header="$t('DischargeTrackingReport.voyageReportStatus')">
                <template #body="{data}">
                  {{data.voyageReportStatus ? $t('DischargeTrackingReport.status.' + data.voyageReportStatus) : ''}}
                </template>
              </Column>
              <Column field="receiptOfDocumentsAndSamplesStatus" :header="$t('DischargeTrackingReport.receiptOfDocumentsAndSamplesStatus')">
                <template #body="{data}">
                  {{data.receiptOfDocumentsAndSamplesStatus ? $t('DischargeTrackingReport.status.' + data.receiptOfDocumentsAndSamplesStatus) : ''}}
                </template>
              </Column>
              <Column field="letterOfProtestSamplesStatus">
                <template #header>
                  <p>
                    {{ $t('DischargeTrackingReport.letterOfProtestSamplesStatus') }}
                    <i class="fa-solid fa-info-circle" v-tooltip="$t('DischargeTrackingReport.infoLetterOfProtestSamples')" />
                  </p>
                </template>
                <template #body="{data}">
                  {{data.letterOfProtestSamplesStatus ? $t('DischargeTrackingReport.status.' + data.letterOfProtestSamplesStatus) : ''}}
                </template>
              </Column>
              <!-- <Column field="letterOfProtestFromMasterStatus" :header="$t('DischargeTrackingReport.letterOfProtestFromMasterStatus')">
                <template #body="{data}">
                  {{data.letterOfProtestFromMasterStatus ? $t('DischargeTrackingReport.status.' + data.letterOfProtestFromMasterStatus) : ''}}
                </template>
              </Column> -->
              <Column field="isOriginSamplePresent" :header="$t('DischargeTrackingReport.isOriginSamplePresent')">
                <template #body="{data}">
                  {{data.isOriginSamplePresent ? $t('yes'): $t('no')}}
                </template>
              </Column>
          </DataTable>
            <!-- <GenericDataTable :configuration="configuration" :category="'discharge'" :name="'DischargeTrackingReport'" ref="dischargeTrackingReportGrid" /> -->
        </div>
    </div>
  </main>
</template>